<div class="fn-card-info" *ngIf="this.cardInfo">
  <app-fn-card-image
    class="fn-card-info__card"
    [cardInfo]="this.cardInfo"
    [supplierId]="this.selectedSupplierId"
    (cardBlocked)="this.cardBlockListener()"
  />
  <app-fn-card-data
    class="fn-card-info__data"
    [cardInfo]="this.cardInfo"
    [hideCardNumber]="!!this.selectedSupplierId"
  />
</div>
